import PropTypes from 'prop-types';
import React from 'react';
import { get, flowRight as compose } from 'lodash';
import { graphql } from '@apollo/client/react/hoc';
import { QUERY_LATEST_BOOKINGS, QUERY_PENDING_REQUESTS_COUNT } from './gql';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

class AdminDashboardUnconnected extends React.Component {
  render() {
    const { children, getLatestBookings, getPendingRequests } = this.props;

    const renderProps = {
      dashboardNums: get(getLatestBookings, 'AdminQueries.getAdminDashboard', {}),
      loading: get(getLatestBookings, 'loading', false),
      pendingRequestsCount: get(getPendingRequests, 'getPendingRequestsCount', {})
    };
    return children(renderProps);
  }
}
AdminDashboardUnconnected.propTypes = {
  getLatestBookings: PropTypes.shape({}).isRequired,
  getPendingRequests: PropTypes.shape({}).isRequired,
  children: ReactChildrenPropType.isRequired
};

export const AdminDashboardContainer = compose(
  graphql(QUERY_LATEST_BOOKINGS, {
    name: 'getLatestBookings',
    options: { fetchPolicy: 'cache-first' }
  }),
  graphql(QUERY_PENDING_REQUESTS_COUNT, {
    name: 'getPendingRequests',
    options: () => ({
      variables: {
        organizationRequestStatus: 'PendingApproval',
        userRequestStatus: 'PendingOrgAssign',
        creditApplicationStatus: 'Pending'
      }
    })
  })
)(AdminDashboardUnconnected);
